/*
Copyright 2022 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the p
oject root for license information.
*/

export enum Section {
  // admin sections
  users = 'users',
  teams = 'teams',
  collections = 'collections',
  cards = 'cards',
  teamcards = 'teamcards',
  articles = 'articles',
  exhibits = 'exhibits',
  roles = 'roles',
  groups = 'groups',
  // home sections
  wall = 'wall',
  archive = 'archive',
  none = ''
}
